import { createContext } from 'react';
import type { TourContextType } from '@/types/product-tour';

export const TourContext = createContext<TourContextType | undefined>(undefined);
